import type { IOrganizationUserDto } from '@treneo/models';

export const getUserDisplayName = (user: IOrganizationUserDto): string => {
  if (user.displayName) {
    return user.displayName;
  }

  const fullName = [user.firstName, user.lastName].filter(Boolean).join(' ');
  if (fullName) {
    return fullName;
  }

  return user.email;
};

export const getUserOptionLabel = (user: IOrganizationUserDto): string => {
  const displayName = getUserDisplayName(user);
  return `${displayName} (${user.email})`;
};
